import { render, staticRenderFns } from "./DisplayX1031.vue?vue&type=template&id=238a6014&"
import script from "./DisplayX1031.vue?vue&type=script&lang=js&"
export * from "./DisplayX1031.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports